/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Dach_BadgeInputs */

const en_negotiation_dach_badge = /** @type {(inputs: Negotiation_Dach_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH`)
};

const de_negotiation_dach_badge = /** @type {(inputs: Negotiation_Dach_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH`)
};

const fr_negotiation_dach_badge = /** @type {(inputs: Negotiation_Dach_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH`)
};

const es_negotiation_dach_badge = /** @type {(inputs: Negotiation_Dach_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH`)
};

const it_negotiation_dach_badge = /** @type {(inputs: Negotiation_Dach_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH`)
};

const nl_negotiation_dach_badge = /** @type {(inputs: Negotiation_Dach_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH`)
};

const pl_negotiation_dach_badge = /** @type {(inputs: Negotiation_Dach_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH`)
};

const fi_negotiation_dach_badge = /** @type {(inputs: Negotiation_Dach_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH`)
};

const da_negotiation_dach_badge = /** @type {(inputs: Negotiation_Dach_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH`)
};

const sv_negotiation_dach_badge = /** @type {(inputs: Negotiation_Dach_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH`)
};

/**
* | output |
* | --- |
* | "DACH" |
*
* @param {Negotiation_Dach_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_dach_badge = /** @type {((inputs?: Negotiation_Dach_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Dach_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_dach_badge(inputs)
	if (locale === "fr") return fr_negotiation_dach_badge(inputs)
	if (locale === "es") return es_negotiation_dach_badge(inputs)
	if (locale === "it") return it_negotiation_dach_badge(inputs)
	if (locale === "nl") return nl_negotiation_dach_badge(inputs)
	if (locale === "pl") return pl_negotiation_dach_badge(inputs)
	if (locale === "fi") return fi_negotiation_dach_badge(inputs)
	if (locale === "da") return da_negotiation_dach_badge(inputs)
	if (locale === "sv") return sv_negotiation_dach_badge(inputs)
	return en_negotiation_dach_badge(inputs)
});